export default __webpack_public_path__ + "static/strings-c637c10f8366a46a51dc218ae069b32e.png";